import instance from "../../utils/axios";

// 🔹 Save Service
export const saveService = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) =>
    formData.append(key, val || "")
  );

  const response = await instance.post("/churches/services/save", formData);
  return response.data;
};
export const saveCampusAndTime = async (payload) => {
    const formData = new URLSearchParams();
    Object.entries(payload || {}).forEach(([key, val]) =>
      formData.append(key, val || "")
    );

    const response = await instance.post("/churches/services/campusesandtime/save", formData);
    return response.data;
  };
  export const saveServiceGallery = async (payload) => {
    const formData = new URLSearchParams();
    Object.entries(payload || {}).forEach(([key, val]) =>
      formData.append(key, val || "")
    );

    const response = await instance.post("/churches/services/servicegallery/save", formData);
    return response.data;
  };

  // 🔹 Delete Service
export const deleteService = async (payload) => {
    const formData = new URLSearchParams();
    Object.entries(payload || {}).forEach(([key, val]) =>
      formData.append(key, val || "")
    );

    const response = await instance.post("/churches/services/delete", formData);
    return response.data;
  };
  export const updateService = async (payload) => {
    const formData = new URLSearchParams();
    Object.entries(payload || {}).forEach(([key, val]) =>
      formData.append(key, val || "")
    );

    const response = await instance.post("/churches/services/update", formData);
    return response.data;
  };

  // 🔹 Update Campus and Time
  export const updateCampusAndTime = async (payload) => {
    const formData = new URLSearchParams();
    Object.entries(payload || {}).forEach(([key, val]) =>
      formData.append(key, val || "")
    );

    const response = await instance.post("/churches/services/campusesandtime/update", formData);
    return response.data;
  };

  // 🔹 Update Service Gallery
  export const updateServiceGallery = async (payload) => {
    const formData = new URLSearchParams();
    Object.entries(payload || {}).forEach(([key, val]) =>
      formData.append(key, val || "")
    );

    const response = await instance.post("/churches/services/servicegallery/update", formData);
    return response.data;
  };
  export const deleteServiceGallery = async (payload) => {
     // Debug payload
    const formData = new URLSearchParams();
      formData.append("_id", payload?._id);
      formData.append("serviceObjId", payload?.serviceObjId);
      formData.append("serviceGalleryObjId", payload?.serviceGalleryObjId);

      // const response = await instance.post("/churches/campuses/campusgallery/delete", formData);
      // return response.data;
    const response = await instance.post(
      "/churches/services/servicegallery/delete",
      payload // sending as JSON
    );
     // Debug response
    return response.data;
  };

  // 🔹 Delete Campus & Time
export const deleteCampusAndTime = async (payload) => {
  const formData = new URLSearchParams();
  formData.append("_id", payload?._id);
  formData.append("serviceObjId", payload?.serviceObjId);
  formData.append("campusandtimeObjId", payload?.campusandtimeObjId);

  const response = await instance.post(
    "/churches/services/campusesandtime/delete",
    formData
  );

  return response.data;
};
